import { useEffect, useState } from 'react';
import { useConfig, useAppState } from '@ynap/immutables-provider';
import { raygun } from '@ynap/clientside-monitoring';
import { getIntelistyleRequestBody } from './utils';
import { fetchProductDetails } from './fetch-utils';
import { useToRecommendedProduct } from './use-to-recommended-product';

const configSelector = (config) => ({
    availableImageSizes: config?.head?.availableImageSizes,
    imageQuality: config?.head?.imageQualityPercentage,
    pdpUrlTemplate: config?.global?.urlConfig?.pdp?.construct,
    baseUrl: config?.global.services.commerce.baseUrl,
    brandId: config?.global.application.brandId,
    clientId: config?.global.services.commerce.clientId,
    intelistyleCountries: config?.head?.pdp?.intelistyle?.countries,
    intelistyleHost: config?.head?.pdp?.intelistyle?.host,
});

export const useIntelistyleWiw = ({ partNumber }) => {
    const [wiw, setWiw] = useState([]);
    const { country, langISO } = useAppState();
    const { baseUrl, brandId, clientId, intelistyleCountries, intelistyleHost } = useConfig(configSelector);

    const intelistyleCountry = !intelistyleCountries?.length ? true : intelistyleCountries?.includes(country);
    const toRecommendedProduct = useToRecommendedProduct();

    useEffect(() => {
        if (intelistyleHost && intelistyleCountry) {
            fetchWearItWith({ baseUrl, brandId, clientId, country, host: intelistyleHost, partNumber, langISO })
                .then((products) => products.map(toRecommendedProduct))
                .then(setWiw);
        }
    }, [country, partNumber, intelistyleHost]);

    return wiw;
};

const fetchWearItWith = async ({ baseUrl, brandId, clientId, country, host, partNumber, langISO }) => {
    const json = await fetchIntelistyle(host, '/getOutfits', getIntelistyleRequestBody(country, partNumber));
    const garments = json?.outfits?.[0]?.garments;

    if (!garments) {
        return [];
    }

    const productsPromise = garments.map(({ remote_product_id }) => async () => {
        const productDetails = await fetchProductDetails({ partNumber: remote_product_id, baseUrl, brandId, clientId, country, langISO });

        if (!productDetails?.buyable) {
            return null;
        } else {
            return productDetails;
        }
    });

    return await Promise.all(productsPromise.map((promise) => promise())).then((products) => products.filter((product) => product));
};

const fetchIntelistyle = async (host, path, body) => {
    try {
        const response = await fetch(`${host}${path}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body),
        });
        if (!response.ok) {
            raygun.helpers.agent('send', {
                error: new Error(`intelistyle fetch error`),
                tags: [`error-intelistyle`, `partNumber: ${body?.product_id}`, `statusCode: ${response.status}`],
            });
            return;
        }

        return await response.json();
    } catch (err) {
        return;
    }
};
